enum SortOrder {
  Ascending = 'ASC',
  Descending = 'DES'
}

export default SortOrder
